import CreateDataContext from "./CreateDataContext";
import { dashboardService } from "../api/dashboardService";

const HomeReducer = (state, action) => {
  switch (action.type) {
    case "fetch_stats_start":
      return { ...state, isLoading: true, error: "" };
    case "fetch_stats_success":
      return { ...state, stats: action.payload, isLoading: false, error: "" };
    case "fetch_stats_error":
      return { ...state, error: action.payload, isLoading: false };
    default:
      return state;
  }
};

const fetchDashboardData = (dispatch) => async (range, startDate, endDate) => {
  dispatch({ type: "fetch_stats_start" });
  try {
    const adminId = sessionStorage.getItem("admin_id") || 1;

    const [userRes, walkRes, treatRes, msgRes] = await Promise.all([
      dashboardService.getUserCounts(adminId, range, startDate, endDate),
      dashboardService.getWalkCounts(adminId, range, startDate, endDate),
      dashboardService.getTreatCount(adminId, range, startDate, endDate),
      dashboardService.getMessageCount(range, startDate, endDate),
    ]);

    if (
      userRes.data?.status &&
      walkRes.data?.status &&
      treatRes.data?.status &&
      msgRes?.status
    ) {
      dispatch({
        type: "fetch_stats_success",
        payload: {
          profiles: userRes.data.data,
          walks: walkRes.data.data.total_walks,
          treats: treatRes.data.data.total_treats,
          messages: msgRes.data.total_messages,
        },
      });
    } else {
      dispatch({
        type: "fetch_stats_error",
        payload: "One or more API requests failed.",
      });
    }
  } catch (err) {
    console.error("Dashboard Fetch Error: ", err);
    dispatch({
      type: "fetch_stats_error",
      payload: "Failed to sync dashboard statistics.",
    });
  }
};

export const { Provider, Context } = CreateDataContext(
  HomeReducer,
  { fetchDashboardData },
  {
    stats: { profiles: null, walks: 0, treats: 0, messages: 0 },
    isLoading: true,
    error: "",
  },
);
